"use strict";

class StationSettingsThemesCtrl {

    constructor($rootScope, $scope, $http, $mdToast, $window)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$window = $window;

        this.settings = {};
        this.settings.theme = {};
        this.settings.theme.color = {};

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        this.colors = [
            ['#FF9800', '#FFD41E', '#F25FA4', '#4EBED4', '#86be40', '#c9252c'],
            ['#3b5998', '#333333', '#CBCBCB', '#715ea1', '#795548', '#50acee'],
        ];

        $scope.miniColorConfig = {
            inline: true
        };

        $scope.$watch(() => {
            return $scope.themes.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

    }

    save() {
        this.$rootScope.saveDisabled = true;
        let data = this.settings;

        this.$http.put('/stationsettings/settings', data)
            .then(() => {

                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object=Themes',
                    hideDelay: 6000,
                    position: ('top right')
                });
                this.$rootScope.saveDisabled = false;
                this.$window.location.reload();
            });
    }

    fetch() {
        this.$http.get('/stationsettings/settings').then(response => {
            this.settings = response.data;
            if(!this.settings.theme){
                this.settings.theme = {};
                this.settings.theme.logo = {};
                this.settings.theme.color = {};
                this.settings.theme.selected = 'default';
                this.settings.theme.backgroundSelected = 'url';
                this.settings.theme.color.main = '#000000';
                this.settings.theme.color.secondary = '#ffffff';
                this.settings.theme.logo.selected = 'default';
            }
        });
    }
}

StationSettingsThemesCtrl.$inject = [
    '$rootScope',
    '$scope',
    '$http',
    '$mdToast',
    '$window'
];

module.exports = StationSettingsThemesCtrl;